import React, { useState } from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DashboardSetting from '../DashboardSetting/DashboardSetting'
import { DashboardWrapper } from './dashboard.styled'
import { DashboardCategory } from '../../constants/DashboardConf'
import { fetchDashboardData } from '../../apis/dashboard'

// const iconMap = {
//   cookie: <img src="/groups.svg" width="62px" alt="groups" />,
//   LineID: <img src="/line.svg" className="mb-1" width="57px" alt="line" />,
//   email: <MailFilled className="mb-2" style={{ color: '#338fe2', fontSize: '44px' }} />,
//   phone: <PhoneFilled className="mb-2" style={{ color: '#046bb4', fontSize: '44px' }} />
// }
// const tmpData = {
//   cht: { age: { '0-17': 0, '18-24': 0, '25-29': 0, '30-34': 0, '35-39': 0, '40-44': 0, '45-49': 0, '50-54': 0, '55-59': 0, '60-64': 0, '65+': 0, unknown: 0 }, gender: { female: 0, male: 0, unknow: 0 }, home: { 南投縣: 0, 台中市: 0, 台北市: 0, 台南市: 0, 台東縣: 0, 嘉義市: 0, 嘉義縣: 0, 基隆市: 0, 宜蘭縣: 0, 屏東縣: 0, 彰化縣: 0, 新北市: 0, 新竹市: 0, 新竹縣: 0, 桃園市: 0, 澎湖縣: 0, 花蓮縣: 0, 苗栗縣: 0, 連江縣: 0, 金門縣: 0, 雲林縣: 0, 高雄市: 0 }, work: { 南投縣: 0, 台中市: 0, 台北市: 0, 台南市: 0, 台東縣: 0, 嘉義市: 0, 嘉義縣: 0, 基隆市: 0, 宜蘭縣: 0, 屏東縣: 0, 彰化縣: 0, 新北市: 0, 新竹市: 0, 新竹縣: 0, 桃園市: 0, 澎湖縣: 0, 花蓮縣: 0, 苗栗縣: 0, 連江縣: 0, 金門縣: 0, 雲林縣: 0, 高雄市: 0 }, interest: {}, web: {}, location: { Others: 0 } },
//   basic: { location: { 南投縣: 0, 台中市: 0, 台北市: 0, 台南市: 0, 台東縣: 0, 嘉義市: 0, 嘉義縣: 0, 基隆市: 0, 宜蘭縣: 0, 屏東縣: 0, 彰化縣: 0, 新北市: 0, 新竹市: 0, 新竹縣: 0, 桃園市: 0, 澎湖縣: 0, 花蓮縣: 0, 苗栗縣: 0, 連江縣: 0, 金門縣: 0, 雲林縣: 0, 高雄市: 0 }, device: {}, browser: {}, os: {} }
// }

const { BRAND } = DashboardCategory
function Dashboard (props) {
  const { t: ln_t } = useTranslation()
  const user = useSelector(state => state.user)
  const { nowBrand, brands } = user || {}
  // const nowGroupData = groups?.find(item => item.id === nowGroup)
  const nowBrandData = brands?.find(item => item.id === nowBrand)
  // const [type, setType] = useState('brand')
  const [content, setContent] = useState({})

  const setupContent = async data => {
    if (data && data?.length) {
      const reqBody = data?.map(({ id, categoryDetail, groupId, brandId, tableName }) => ({ id, categoryDetail, groupId, brandId, tableName }))
      const res = await fetchDashboardData(reqBody)
      if (res?.status === 200) setContent(res?.data)
      return
    }
    if (nowBrandData?.siteChartEnable) return
    Modal.info({
      title: ln_t('dashboard.noSetting'),
      content: ln_t('message.info.noSettingInDashboard')
    })
  }

  return (
    <div>
      {/* <Radio.Group
        buttonStyle="solid"
        optionType="button"
        value={type}
        onChange={e => setType(e.target.value)}
        options={[{ value: 'group', label: ln_t('dashboard.group') }, { value: 'brand', label: ln_t('dashboard.brand') }]}
      /> */}

      <DashboardWrapper>
        <DashboardSetting
          fixedData={nowBrandData}
          type={BRAND}
          content={content}
          setContent={setContent}
          setupContentFunc={setupContent}
          noHeader
          renderBasedOnStatus
          allowRefresh
        />
      </DashboardWrapper>
    </div>
  )
}

export default Dashboard
